export const TABLE_PADDING = 'pt-[24px] p-[40px]';
